export * from './payrollDataActivityReport.Component';
export * from './payrollDataActivityReport.service';



// WEBPACK FOOTER //
// ./src/app/PayrollDataActivityreport/index.ts